var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.subcategory)?_c('span',[_vm._v(_vm._s(_vm.subcategory.category.name)+" / "+_vm._s(_vm.subcategory.name))]):(_vm.subcategoryId)?_c('kbd',[_vm._v(_vm._s(_vm.subcategoryId))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }